import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/task/task-type/query/', 'task type');

tbl.add(new Xtc('title', 'Task'))
// tbl.add(new Xtc('create', 'Created').renderSlot('date_create'))
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

